import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertService } from 'services/alert.service';
import { ApplicationService } from 'services/application.service';
import { ExcelService } from 'services/excel.service';
import { UserService } from 'services/user.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-customerreport',
  templateUrl: './customerreport.component.html',
  styleUrls: ['./customerreport.component.scss']
})
export class CustomerreportComponent implements OnInit {
  data: any;
  excelColumns: string[] = [];
  form!: FormGroup;
  pipe = new DatePipe('en-US');
  today: Date = new Date();
  maxDate = '';
  getData: { fromDate: any; toDate: any; } = { fromDate: null, toDate: null };
  toMinDate = '';
  toMaxDate = '';
  serviceProviderList: any[] = [];

  constructor(private applicationService: ApplicationService,
    private excelService: ExcelService,
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    private userService: UserService) {
    this.initializeValidators();
  }

  ngOnInit() {
    this.today = new Date();
    this.maxDate = this.pipe.transform(this.today, 'yyyy-MM-dd') || '';
    this.loadServiceProviders();
    this.form.controls['toDate'].disable();
  }

  initializeValidators() {
    this.form = this.formBuilder.group({
      serviceProvider: [''],
      fromDate: [''],
      toDate: [{ value: '', disabled: true }]
    });
  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }

  loadServiceProviders() {
    this.userService.getServiceProviderType().subscribe((result) => {
      this.serviceProviderList = result || [];
    });
  }

  dateChangeEvent() {
    const fromDate = this.form.value.fromDate;
    if (fromDate) {
      this.form.controls['toDate'].enable();
      this.toMinDate = this.pipe.transform(fromDate, 'yyyy-MM-dd') || '';
      this.form.controls['toDate'].setValidators([Validators.required]);
      this.form.controls['toDate'].updateValueAndValidity();

      const toDateValue = this.form.value.toDate;
      if (toDateValue) {
        const startDate = new Date(fromDate);
        const selectedToDate = new Date(toDateValue);
        if (selectedToDate <= startDate) {
          this.form.controls['toDate'].setValue('');
        }
      }
    } else {
      this.form.controls['toDate'].setValue('');
      this.form.controls['toDate'].disable();
      this.form.controls['toDate'].clearValidators();
      this.form.controls['toDate'].updateValueAndValidity();
      this.toMinDate = '';
    }
  }

  onSubmit() {
    if (this.form.invalid) {
      this.validateFormControl();
      return;
    }

    const fromDateValue = this.form.value.fromDate;
    const toDateValue = this.form.value.toDate;

    if (fromDateValue) {
      if (!toDateValue) {
        this.alertService.info('Please select To Date.');
        return;
      }

      const date1 = new Date(fromDateValue);
      const date2 = new Date(toDateValue);

      if (date2 <= date1) {
        this.alertService.info('To Date must be greater than From Date.');
        return;
      }

      // const differenceDays = (date2.getTime() - date1.getTime()) / (1000 * 3600 * 24);
      // if (differenceDays > 31) {
      //   this.alertService.info('The selected date span can not be larger than 31 days');
      //   return;
      // }

      // Check 3-month limit
      const threeMonthsAfterFromDate = new Date(date1);
      threeMonthsAfterFromDate.setMonth(threeMonthsAfterFromDate.getMonth() + 3);

      if (date2 > threeMonthsAfterFromDate) {
        this.alertService.info('The selected date range cannot be larger than 3 months.');
        return;
      }
    }

    const payload: any = {};
    if (this.form.value.serviceProvider) {
      payload.serviceProvider = this.form.value.serviceProvider;
    }

    if (fromDateValue && toDateValue) {
      payload.fromDate = this.formatDate(fromDateValue);
      payload.toDate = this.formatDate(toDateValue, '23:59:59');
    }

    this.applicationService.getCustomerReport(payload).subscribe(result => {
      this.data = result;

      if (!this.data || this.data.length === 0) {
        this.alertService.info('No data available to export');
        return;
      }

      this.excelColumns = [
        'First Name',
        'Surname',
        'Customer Number',
        'Contact Number',
        'Email Address',
        'FNO',
        'Application Number',
        'Application Status',
        'Product',
        'Product Type',
        'Vumatel Order Number',
        'Order Activated Date',
        'Start Date(First Payment)',
        'Order Placed Date',
        'Expiry Date',
        'Last Payment Date',
        'EasyPay Number',
        'Debit Run Date',
        'FSAN Number',
        'Address ',
        'City ',
        'Region ',
        'Sales Rep Code',
        'Reseller Code',
        'Reseller Sales Code'
      ];

      this.excelService.exportAsExcelFile(this.data, 'Customer Report', this.excelColumns);
    });
  }

  clearFilters() {
    this.form.reset({
      serviceProvider: '',
      fromDate: '',
      toDate: ''
    });

    this.form.controls['toDate'].disable();
    this.toMinDate = '';
    this.toMaxDate = '';
    this.data = null;
    this.form.markAsPristine();
    this.form.markAsUntouched();
  }

  formatDate(dateValue: any, timeString = '00:00:00'): string {
    const date = new Date(dateValue);
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day} ${timeString}`;
  }

}
